import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, MapPin } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-[#080300] pt-20 pb-10 border-t border-brand-gold/10" data-id="element-115">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="flex justify-center mb-16" data-id="element-117">
          <Logo height={160} data-id="element-118" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-119">
          {/* Col 1: About */}
          <div data-id="element-120">
            <p className="text-brand-cream/70 leading-relaxed text-sm" data-id="element-121">
              Cabrera Resto-Bar — Inspirados en el Meatpacking District de Nueva
              York. Sabor, ambiente y experiencia en Bogotá.
            </p>
          </div>

          {/* Col 2: Navigation */}
          <div data-id="element-122">
            <h4 className="text-brand-gold font-serif font-bold mb-6 tracking-wider text-sm" data-id="element-123">
              NAVEGACIÓN
            </h4>
            <ul className="space-y-3" data-id="element-124">
              {[{
              name: 'Inicio',
              to: '/'
            }, {
              name: 'Quiénes Somos',
              to: '/quienes-somos'
            }, {
              name: 'Menú',
              to: '/menu'
            }, {
              name: 'Reservas',
              to: '/reservas'
            }, {
              name: 'Sedes',
              to: '/sedes'
            }, {
              name: 'Contacto',
              to: '/contacto'
            }].map(item => <li key={item.name} data-id="element-125">
                  <Link to={item.to} className="text-brand-cream/70 hover:text-brand-gold transition-colors text-sm" data-id="element-126">
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Col 3: Locations */}
          <div data-id="element-127">
            <h4 className="text-brand-gold font-serif font-bold mb-6 tracking-wider text-sm" data-id="element-128">
              NUESTRAS SEDES
            </h4>
            <ul className="space-y-4" data-id="element-129">
              <li className="flex items-start" data-id="element-130">
                <MapPin size={16} className="text-brand-gold mt-1 mr-2 flex-shrink-0" data-id="element-131" />
                <span className="text-brand-cream/70 text-sm" data-id="element-132">
                  <strong className="text-brand-cream" data-id="element-133">Zona T:</strong> Cra. 12a
                  #83-23
                </span>
              </li>
              <li className="flex items-start" data-id="element-134">
                <MapPin size={16} className="text-brand-gold mt-1 mr-2 flex-shrink-0" data-id="element-135" />
                <span className="text-brand-cream/70 text-sm" data-id="element-136">
                  <strong className="text-brand-cream" data-id="element-137">Unicentro:</strong> Calle
                  127, Food Corner
                </span>
              </li>
              <li className="flex items-start" data-id="element-138">
                <MapPin size={16} className="text-brand-gold mt-1 mr-2 flex-shrink-0" data-id="element-139" />
                <span className="text-brand-cream/70 text-sm" data-id="element-140">
                  <strong className="text-brand-cream" data-id="element-141">Fontanar:</strong> Local
                  202
                </span>
              </li>
              <li className="flex items-start" data-id="element-142">
                <MapPin size={16} className="text-brand-gold mt-1 mr-2 flex-shrink-0" data-id="element-143" />
                <span className="text-brand-cream/70 text-sm" data-id="element-144">
                  <strong className="text-brand-cream" data-id="element-145">La Colina:</strong>{' '}
                  Tercer piso, The Social
                </span>
              </li>
              <li className="flex items-start" data-id="element-146">
                <MapPin size={16} className="text-brand-gold mt-1 mr-2 flex-shrink-0" data-id="element-147" />
                <span className="text-brand-cream/70 text-sm" data-id="element-148">
                  <strong className="text-brand-cream" data-id="element-149">Salitre:</strong> Bogotá
                </span>
              </li>
            </ul>
          </div>

          {/* Col 4: Social */}
          <div data-id="element-150">
            <h4 className="text-brand-gold font-serif font-bold mb-6 tracking-wider text-sm" data-id="element-151">
              SÍGUENOS
            </h4>
            <div className="flex space-x-4 mb-4" data-id="element-152">
              <a href="https://instagram.com/cabrera.restobar" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-brand-primary border border-brand-gold/30 flex items-center justify-center text-brand-cream hover:bg-brand-gold hover:text-brand-primary transition-all" data-id="element-153">
                <Instagram size={18} data-id="element-154" />
              </a>
              <a href="https://facebook.com/cabrera.restobar" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-brand-primary border border-brand-gold/30 flex items-center justify-center text-brand-cream hover:bg-brand-gold hover:text-brand-primary transition-all" data-id="element-155">
                <Facebook size={18} data-id="element-156" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-brand-primary border border-brand-gold/30 flex items-center justify-center text-brand-cream hover:bg-brand-gold hover:text-brand-primary transition-all" data-id="element-157">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-158">
                  <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-159" />
                </svg>
              </a>
            </div>
            <p className="text-brand-cream/70 text-sm" data-id="element-160">@cabrera.restobar</p>
          </div>
        </div>

        <div className="h-px w-full bg-brand-gold/20 mb-8" data-id="element-161"></div>

        <div className="flex flex-col md:flex-row justify-between items-center text-xs text-brand-cream/50" data-id="element-162">
          <p data-id="element-163">© 2026 Cabrera Resto-Bar. Todos los derechos reservados.</p>
          <p className="mt-2 md:mt-0" data-id="element-164">Sitio web diseñado por NovaWeb 🚀</p>
        </div>
      </div>
    </footer>;
}